module.exports = __webpack_public_path__ + "img/CangNanRM.f4975629.jpg";